
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 47.62 47.62"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Camada 2"}},[_c('g',{attrs:{"data-name":"Camada 1"}},[_c('circle',{attrs:{"cx":"23.81","cy":"23.81","r":"23.81","fill":"#d45352"}}),_c('path',{attrs:{"d":"M27.39 35.64h-2.46V13.19a1.67 1.67 0 10-2.79-1.25 1.65 1.65 0 00.56 1.25v22.45h-2.46c-.07 0-.13.19-.13.43v.85c0 .24.06.44.13.44h7.15c.06 0 .12-.19.12-.44v-.85c0-.24-.06-.43-.12-.43z","fill":"#fff"}})])])])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/network_module/object_forms/pole.svg